// extracted by mini-css-extract-plugin
export default {"element":"element--i6Ss","title":"title--UkUk","car-type-button":"car-type-button--H9cB","reset":"reset--KvC4"};